import { useEffect, useState } from 'react';
import OrganisationsList from './OrganisationManagement/OrganisationsList';
import LandingPageDashboard from './LandingPageDashboard'; // Import the new component
import { Switch, Route, useRouteMatch } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { IOrganisationState } from '../commonUtils/Redux/Global/globalShared';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { CircularLoader } from '@forge/common';

interface IBMSPFeatureRequiredProps {
  isLandingPageDashboard?: boolean; // Add this prop to accept the flag
  highestRole?: string;
}

export const DashboardFeature = (props: IBMSPFeatureRequiredProps) => {
  const routeMatch = useRouteMatch();
  const orgSelected = useSelector((state: IOrganisationState) => state.globalShared.gatewaySelectedOrganisation);
  const flags = useFlags();

  const [toggleHome, setToggleHome] = useState(props.isLandingPageDashboard)

  useEffect(() => {
    if(props.isLandingPageDashboard) {
      setToggleHome(flags?.enableBacsFlow?.includes(orgSelected?.id))
    }
  }, [orgSelected, flags, props.isLandingPageDashboard]);

  if (!orgSelected && props.isLandingPageDashboard) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '80vh',
        width: '100%',
      }}>
        <CircularLoader size="regular" />
      </div>
    );
  }

  return (
    <>
      {routeMatch ? (
        <Switch>
          <Route
            path={`${routeMatch.path === '/' ? '' : routeMatch.path}/`}
          >
            {/* Conditional rendering based on the flag */}
            {props.isLandingPageDashboard ? (
              <LandingPageDashboard key={orgSelected?.id} highestRole={props.highestRole} />
            ) : (
              <OrganisationsList />
            )}
          </Route>
        </Switch>
      ) : null}
    </>
  );
};

export default DashboardFeature;
